import { ScheduleService } from './../schedule/schedule.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Civilstatus } from 'app/main/interface/civilstatus';
import { Convenio } from 'app/main/interface/convenio';
import { Gender } from 'app/main/interface/gender';
import { Nationality } from 'app/main/interface/nationality';
import { Patient } from 'app/main/interface/patient';
import { Race } from 'app/main/interface/race';
import { UnregisteredNewService } from 'app/main/unregistered-new/unregistered-new.service';

import * as moment from 'moment';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { SnackBarService } from 'app/services/snackbar.service';
import { Utils } from 'app/utils/utils';

@Component({
  selector: 'app-unregistered-new',
  templateUrl: './unregistered-new.component.html',
  styleUrls: ['./unregistered-new.component.scss']
})
export class UnregisteredNewComponent implements OnInit {

  patientForm: FormGroup
  civilStatus = new Array <Civilstatus>()
  convenio= new Array<Convenio>() 
  gender= new Array <Gender>()
  nationality= new Array <Nationality>()
  race= new Array <Race>()
  patient: Patient;
  patientEdit: string;
  typePage: string = 'edit';

  errorForm: Boolean 

   
  disabled: boolean = false;

  insuranceControl = new FormControl();

  _unsubscribeAll: Subject<any>;

  constructor(
    private formBuilder: FormBuilder,
    private unregisteredNewService: UnregisteredNewService,
    private scheduleService: ScheduleService,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: SnackBarService,
  ) {

    this._unsubscribeAll = new Subject<any>();
    this.patient = new Patient();
   

   }

  ngOnInit(): void {

    this.getList() 
    this.createForm();
    this.filterInsurance();

  }

  createForm(patient?: Patient){

    this.patientForm = this.formBuilder.group({

      idPaciente: [patient ? patient.idPaciente : ''],
      nomePaciente: [patient ? patient.nomePaciente : '', [Validators.required]],
      dataNascimento: [patient ? moment(patient.dataNascimento).format('DD/MM/YYYY') : '', [Validators.required]],
      cpf: [patient ? patient.cpf : '', [Validators.required]],
      rg: [patient ? patient.rg : ''],
      eMail: [patient ? patient.eMail : ''],
      nomeMae: [patient ? patient.nomeMae : ''],
      telefoneCelular: [patient ? patient.telefoneCelular : '', [Validators.required]],
      telefone: [patient ? patient.telefone : ''],
      nacionalidade: [patient ? patient.nacionalidade : ''],
      prontuario: [patient ? patient.prontuario : ''],
      racaPaciente: [patient ? patient.racaPaciente : ''],
      estadoCivil: [patient ? patient.estadoCivil : ''],
      sexo: [patient ? patient.sexo : ''],
      logradouro: [patient ? patient.logradouro : ''],
      bairro: [patient ? patient.bairro : ''],
      complemento: [patient ? patient.complemento : ''],
      numeroLogradouro: [patient ? patient.numeroLogradouro : ''],
      municipio: [patient ? patient.municipio : ''],
      codigoIBGE: [patient ? patient.codigoIBGE : ''],
      uf: [patient ? patient.uf : ''],
      cep: [patient ? patient.cep : ''],
      nomeConvenio: [patient ? patient.nomeConvenio : '', [Validators.required]],
      idConvenio: [patient ? patient.idConvenio : ''],
      carteiraConvenio: [patient ? patient.carteiraConvenio : ''],
      validadeCarteiraConvenio: [patient ? moment(patient.validadeCarteiraConvenio).format('DD/MM/YYYY') : '', [Validators.required]],
      situacao: ['Ativo'],

    })

  }


  getPatient(idPatient) {
    this.unregisteredNewService.getPatientById(idPatient)
      .then(patient => {
        if (patient.idPaciente) {
          this.patient = new Patient();
          this.patient = patient;
          let insurance: Convenio = {
            nomeConvenio: this.patient.nomeConvenio,
            idConvenio: this.patient.idConvenio,
            cnpj: '',
            numeroANS: '',
            situacaoConvenio: 'Ativo'
          }
          this.insuranceControl.setValue(insurance)
          this.createForm(this.patient)
        }
      })
  }

  getSexoList() {
    this.unregisteredNewService.getSexoList()
      .then((result) => {
        this.gender = result;
      })
  }
  getRaceList() {
    this.unregisteredNewService.getRaceList()
      .then((result) => {
        this.race = result;
      })
  }

  getNationalityList() {
    this.unregisteredNewService.getnationalityList()
      .then((result) => {
        this.nationality = result;
      })
  }

  getMaritalStatusList() {
    this.unregisteredNewService.getMaritalStatusList()
      .then((result) => {
        this.civilStatus = result;
      })
  }
 async getInsuranceList(filter?) {
    let resultInsurance = await this.scheduleService.getInsuranceList();
        
    this.convenio = Utils.extractorArray(
        resultInsurance.idConvenio ? Array(resultInsurance) : resultInsurance, "agendaPacienteOnline");
  }

  getList() {
    this.getSexoList();
    this.getRaceList();
    this.getNationalityList();
    this.getMaritalStatusList();
    this.getInsuranceList();
  }

  filterInsurance() {
    this.insuranceControl.valueChanges
      .pipe(
        takeUntil(this._unsubscribeAll),
        debounceTime(500),
        distinctUntilChanged()
      ).subscribe((result) => {
        if (result.idConvenio) {
          this.patientForm.controls['nomeConvenio'].setValue(result.nomeConvenio);
          this.patientForm.controls['idConvenio'].setValue(result.idConvenio);
        } else {
          this.getInsuranceList(result);
        }
      })
  }

  dateFormater1(data) {
    if (data) {
      let dateField = "";
      const date = String(data);
      let firstField = date.split("/");
      dateField =
        firstField[2] + "-" + firstField[1] + "-" + firstField[0]
      return dateField;
    }
  }

  dateFormater2(data) {
    if (data) {
      let dateField = "";
      const date = String(data);
      let firstField = date.split("-");
      dateField =
        firstField[0] + "/" + firstField[1] + "/" + firstField[2]
      return dateField;
    }
  }

  displayInsurance(obj?: Convenio): string {
    if (obj) {
      if (!obj.nomeConvenio) {
        return null;
      }
      return obj.nomeConvenio;
    }
    return null;
  }

  navigate(action?) {
    
      this.router.navigate(['/']);
    
  }

  buscarCep() {
    const cep = this.patientForm.controls['cep'].value;
    this.unregisteredNewService.getCep(cep)
      .then((result) => {
        this.patientForm.patchValue({
          bairro: result.bairro,
          complemento: result.complemento,
          codigoIBGE: result.ibge,
          uf: result.uf,
          logradouro: result.logradouro,
          municipio: result.localidade,
        })
      })

  }

  checkFields() {

    let valid = true;
    if (!this.patientForm.controls['nomePaciente'].value) {
      this.snackBar.errorMessage(`Preencha o campo Paciente.`)
      
      valid = false;
    } else if (!this.patientForm.controls['cpf'].value) {
      this.snackBar.errorMessage("Selecione um cpf válido.")
      
      valid = false;
    } else if (!this.patientForm.controls['nomeConvenio'].value) {
      this.snackBar.errorMessage("Selecione seu convenio.")
      
      valid = false;
    }
    else if (
      !this.patientForm.controls['dataNascimento'].valid ||
      !this.patientForm.controls['telefoneCelular'].valid ||
      !this.patientForm.controls['nomeConvenio'].valid 
      

    ) {
      this.snackBar.errorMessage("Verifique os campos em destaque.")
      

      this.patientForm.controls['nomePaciente'].markAsTouched();
      this.patientForm.controls['cpf'].markAsTouched();
      this.patientForm.controls['dataNascimento'].markAsTouched();
      this.patientForm.controls['telefoneCelular'].markAsTouched();
      this.patientForm.controls['nomeConvenio'].markAsTouched();
      valid = false;
    }
    
    
    return valid;
  }

  onSubmit() {
    if (!this.checkFields()) return;
    let patient: Patient;
    patient = this.patientForm.getRawValue();
    localStorage.setItem("nascimentopaciente", JSON.stringify(patient.dataNascimento));
    patient.dataNascimento = this.dateFormater1(patient.dataNascimento);
    patient.validadeCarteiraConvenio = this.dateFormater1(patient.validadeCarteiraConvenio);
    
    
    this.snackBar.successMessage('Salvando')
    this.unregisteredNewService.savePatient(patient)
      .then((result) => {
        this.snackBar.successMessage('Salvo com sucesso!')   
        localStorage.setItem("cpfpaciente", JSON.stringify(patient.cpf));
        
       this.router.navigate([`/`])          

      }).catch((error) => {   
        localStorage.removeItem('cpfpaciente');
        localStorage.removeItem('nascimentopaciente');     
        this.snackBar.errorMessage('Ocorreu um erro ao salvar os dados!')
        
      })
  }

}
